<div class="w-full" [formGroup]="minMaxForm">
  <div class="flex space-x-3">
    <div class="w-full">
      <div class="flex items-center rounded-md bg-white px-3 outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-blue-royal h-[36px] dark:bg-secondary dark:outline-secondary"
           [class.!outline-red-500]="required && minMaxForm.get('min')?.errors?.['required'] && minMaxForm.get('min')?.touched">
        <div *ngIf="prefix" class="shrink-0 select-none text-gray-500 sm:text-sm sm:leading-6 dark:text-gray-400">{{ prefix }}</div>
        <input
          type="text"
          inputmode="numeric"
          [value]="minDisplayValue"
          (input)="onFormattedInput('min', $event)"
          [attr.max]="max"
          [placeholder]="'Min ' + placeholder"
          class="block min-w-0 grow border-0 bg-transparent py-1.5 pl-1 pr-3 text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-0 focus:border-0 focus:shadow-none sm:text-sm sm:leading-6 dark:text-white dark:placeholder:text-gray-500"
        />
        <div *ngIf="suffix" class="shrink-0 select-none text-gray-500 sm:text-sm sm:leading-6 dark:text-gray-400">{{ suffix }}</div>
      </div>
    </div>
    <div class="w-full">
      <div class="flex items-center rounded-md bg-white px-3 outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-blue-royal h-[36px] dark:bg-secondary dark:outline-secondary"
           [class.!outline-red-500]="required && minMaxForm.get('max')?.errors?.['required'] && minMaxForm.get('max')?.touched">
        <div *ngIf="prefix" class="shrink-0 select-none text-gray-500 sm:text-sm sm:leading-6 dark:text-gray-400">{{ prefix }}</div>
        <input
          type="text"
          inputmode="numeric"
          [value]="maxDisplayValue"
          (input)="onFormattedInput('max', $event)"
          [attr.max]="max"
          [placeholder]="'Max ' + placeholder"
          class="block min-w-0 grow border-0 bg-transparent py-1.5 pl-1 pr-3 text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-0 focus:border-0 focus:shadow-none sm:text-sm sm:leading-6 dark:text-white dark:placeholder:text-gray-500"
        />
        <div *ngIf="suffix" class="shrink-0 select-none text-gray-500 sm:text-sm sm:leading-6 dark:text-gray-400">{{ suffix }}</div>
      </div>
    </div>
  </div>
</div>
